/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AvatarCatalogueResponse } from '../models/avatarCatalogueResponse';

import type { AvatarFacesResponse } from '../models/avatarFacesResponse';

import type { AvatarSessionRead } from '../models/avatarSessionRead';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { LabProviderCatalogue } from '../models/labProviderCatalogue';

import type { LabTokenRequest } from '../models/labTokenRequest';

import type { LabTokenResponse } from '../models/labTokenResponse';

import type { LivekitAvailabilityResponse } from '../models/livekitAvailabilityResponse';

import type { LivekitSessionRequest } from '../models/livekitSessionRequest';

import type { LivekitSessionResponse } from '../models/livekitSessionResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List the avatar faces the selected video-avatar provider can render.

Scoped through the SAME resolver as ``GET /api/v1/avatars/catalogue`` so the
two can never drift: a face id is vendor-specific, so offering one the
sysadmin's chosen vendor cannot render would produce a call that renders
nothing. With no sysadmin choice made the catalogue default vendor applies.
 * @summary List Faces
 */
export const listFacesApiV1AvatarsFacesGet = (signal?: AbortSignal) => {
  return customInstance<AvatarFacesResponse>({
    url: `/api/v1/avatars/faces`,
    method: 'GET',
    signal
  });
};

export const getListFacesApiV1AvatarsFacesGetQueryKey = () => {
  return [`/api/v1/avatars/faces`] as const;
};

export const getListFacesApiV1AvatarsFacesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFacesApiV1AvatarsFacesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>
  > = ({ signal }) => listFacesApiV1AvatarsFacesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListFacesApiV1AvatarsFacesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>
>;
export type ListFacesApiV1AvatarsFacesGetQueryError = unknown;

export function useListFacesApiV1AvatarsFacesGet<
  TData = Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
          TError,
          Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFacesApiV1AvatarsFacesGet<
  TData = Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
          TError,
          Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFacesApiV1AvatarsFacesGet<
  TData = Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Faces
 */

export function useListFacesApiV1AvatarsFacesGet<
  TData = Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFacesApiV1AvatarsFacesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListFacesApiV1AvatarsFacesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List the avatar faces + voices available under the selected providers.

The provider-scoping seam: a face or voice id is handed straight to its
vendor's plugin, so a picker that offered another vendor's ids would produce
a call that renders nothing. Read-only; no vendor credential is returned.
 * @summary Get Avatar Catalogue
 */
export const getAvatarCatalogueApiV1AvatarsCatalogueGet = (
  signal?: AbortSignal
) => {
  return customInstance<AvatarCatalogueResponse>({
    url: `/api/v1/avatars/catalogue`,
    method: 'GET',
    signal
  });
};

export const getGetAvatarCatalogueApiV1AvatarsCatalogueGetQueryKey = () => {
  return [`/api/v1/avatars/catalogue`] as const;
};

export const getGetAvatarCatalogueApiV1AvatarsCatalogueGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAvatarCatalogueApiV1AvatarsCatalogueGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>
  > = ({ signal }) => getAvatarCatalogueApiV1AvatarsCatalogueGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAvatarCatalogueApiV1AvatarsCatalogueGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>
>;
export type GetAvatarCatalogueApiV1AvatarsCatalogueGetQueryError = unknown;

export function useGetAvatarCatalogueApiV1AvatarsCatalogueGet<
  TData = Awaited<
    ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
          >,
          TError,
          Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvatarCatalogueApiV1AvatarsCatalogueGet<
  TData = Awaited<
    ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
          >,
          TError,
          Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvatarCatalogueApiV1AvatarsCatalogueGet<
  TData = Awaited<
    ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Avatar Catalogue
 */

export function useGetAvatarCatalogueApiV1AvatarsCatalogueGet<
  TData = Awaited<
    ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvatarCatalogueApiV1AvatarsCatalogueGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAvatarCatalogueApiV1AvatarsCatalogueGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return the STT/TTS/avatar provider catalogue (single-sourced from config).
 * @summary Get Providers
 */
export const getProvidersApiV1AvatarsLabProvidersGet = (
  signal?: AbortSignal
) => {
  return customInstance<LabProviderCatalogue>({
    url: `/api/v1/avatars/lab/providers`,
    method: 'GET',
    signal
  });
};

export const getGetProvidersApiV1AvatarsLabProvidersGetQueryKey = () => {
  return [`/api/v1/avatars/lab/providers`] as const;
};

export const getGetProvidersApiV1AvatarsLabProvidersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetProvidersApiV1AvatarsLabProvidersGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>
  > = ({ signal }) => getProvidersApiV1AvatarsLabProvidersGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProvidersApiV1AvatarsLabProvidersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>
>;
export type GetProvidersApiV1AvatarsLabProvidersGetQueryError = unknown;

export function useGetProvidersApiV1AvatarsLabProvidersGet<
  TData = Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
          TError,
          Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProvidersApiV1AvatarsLabProvidersGet<
  TData = Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
          TError,
          Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProvidersApiV1AvatarsLabProvidersGet<
  TData = Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Providers
 */

export function useGetProvidersApiV1AvatarsLabProvidersGet<
  TData = Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProvidersApiV1AvatarsLabProvidersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProvidersApiV1AvatarsLabProvidersGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mint a LiveKit room token + dispatch the avatar agent with chosen providers.

Sysadmin-only (both this route and, transitively, the agent it dispatches).
The caller's own PanLuma JWT rides as dispatch metadata so the agent runs
under the sysadmin's tenant/RLS for MCP tool calls. A thin provider-switching
wrapper over the shared ``AvatarSessionService`` — the Lab therefore persists an
``avatar_sessions`` row + gets a worker-written transcript exactly like a tenant
session, just with catalogue-validated provider picks.
 * @summary Create Lab Token
 */
export const createLabTokenApiV1AvatarsLabTokenPost = (
  labTokenRequest: LabTokenRequest,
  signal?: AbortSignal
) => {
  return customInstance<LabTokenResponse>({
    url: `/api/v1/avatars/lab/token`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: labTokenRequest,
    signal
  });
};

export const getCreateLabTokenApiV1AvatarsLabTokenPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLabTokenApiV1AvatarsLabTokenPost>>,
    TError,
    { data: LabTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLabTokenApiV1AvatarsLabTokenPost>>,
  TError,
  { data: LabTokenRequest },
  TContext
> => {
  const mutationKey = ['createLabTokenApiV1AvatarsLabTokenPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLabTokenApiV1AvatarsLabTokenPost>>,
    { data: LabTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createLabTokenApiV1AvatarsLabTokenPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLabTokenApiV1AvatarsLabTokenPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLabTokenApiV1AvatarsLabTokenPost>>
>;
export type CreateLabTokenApiV1AvatarsLabTokenPostMutationBody =
  LabTokenRequest;
export type CreateLabTokenApiV1AvatarsLabTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Lab Token
 */
export const useCreateLabTokenApiV1AvatarsLabTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLabTokenApiV1AvatarsLabTokenPost>>,
      TError,
      { data: LabTokenRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLabTokenApiV1AvatarsLabTokenPost>>,
  TError,
  { data: LabTokenRequest },
  TContext
> => {
  const mutationOptions =
    getCreateLabTokenApiV1AvatarsLabTokenPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Report whether LiveKit avatar sessions can be started on this deployment.

Lets the frontend gate the chat panel's call button so tenants on a
deployment without LiveKit credentials never see a dead affordance. Config
presence only — no room is touched and no credential material is returned.
 * @summary Get Livekit Availability
 */
export const getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet = (
  signal?: AbortSignal
) => {
  return customInstance<LivekitAvailabilityResponse>({
    url: `/api/v1/avatars/livekit/availability`,
    method: 'GET',
    signal
  });
};

export const getGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGetQueryKey =
  () => {
    return [`/api/v1/avatars/livekit/availability`] as const;
  };

export const getGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
        >
      >
    > = ({ signal }) =>
      getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
      >
    >
  >;
export type GetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGetQueryError =
  unknown;

export function useGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet<
  TData = Awaited<
    ReturnType<typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet<
  TData = Awaited<
    ReturnType<typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet<
  TData = Awaited<
    ReturnType<typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Livekit Availability
 */

export function useGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet<
  TData = Awaited<
    ReturnType<typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mint a LiveKit avatar session (token + dispatch) and persist its row.
 * @summary Start Avatar Session
 */
export const startAvatarSessionApiV1AvatarsLivekitSessionsPost = (
  livekitSessionRequest: LivekitSessionRequest,
  signal?: AbortSignal
) => {
  return customInstance<LivekitSessionResponse>({
    url: `/api/v1/avatars/livekit/sessions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: livekitSessionRequest,
    signal
  });
};

export const getStartAvatarSessionApiV1AvatarsLivekitSessionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof startAvatarSessionApiV1AvatarsLivekitSessionsPost>
      >,
      TError,
      { data: LivekitSessionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof startAvatarSessionApiV1AvatarsLivekitSessionsPost>
    >,
    TError,
    { data: LivekitSessionRequest },
    TContext
  > => {
    const mutationKey = ['startAvatarSessionApiV1AvatarsLivekitSessionsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof startAvatarSessionApiV1AvatarsLivekitSessionsPost>
      >,
      { data: LivekitSessionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return startAvatarSessionApiV1AvatarsLivekitSessionsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type StartAvatarSessionApiV1AvatarsLivekitSessionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof startAvatarSessionApiV1AvatarsLivekitSessionsPost>
    >
  >;
export type StartAvatarSessionApiV1AvatarsLivekitSessionsPostMutationBody =
  LivekitSessionRequest;
export type StartAvatarSessionApiV1AvatarsLivekitSessionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Start Avatar Session
 */
export const useStartAvatarSessionApiV1AvatarsLivekitSessionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof startAvatarSessionApiV1AvatarsLivekitSessionsPost>
      >,
      TError,
      { data: LivekitSessionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof startAvatarSessionApiV1AvatarsLivekitSessionsPost>>,
  TError,
  { data: LivekitSessionRequest },
  TContext
> => {
  const mutationOptions =
    getStartAvatarSessionApiV1AvatarsLivekitSessionsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Read a persisted avatar session (incl. transcript), scoped to the caller.
 * @summary Get Avatar Session
 */
export const getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet = (
  sessionId: string,
  signal?: AbortSignal
) => {
  return customInstance<AvatarSessionRead>({
    url: `/api/v1/avatars/livekit/sessions/${sessionId}`,
    method: 'GET',
    signal
  });
};

export const getGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGetQueryKey =
  (sessionId?: string) => {
    return [`/api/v1/avatars/livekit/sessions/${sessionId}`] as const;
  };

export const getGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet>
    >,
    TError = HTTPValidationError
  >(
    sessionId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGetQueryKey(
        sessionId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
        >
      >
    > = ({ signal }) =>
      getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet(
        sessionId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sessionId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet>
    >
  >;
export type GetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGetQueryError =
  HTTPValidationError;

export function useGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet>
  >,
  TError = HTTPValidationError
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet>
  >,
  TError = HTTPValidationError
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet>
  >,
  TError = HTTPValidationError
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Avatar Session
 */

export function useGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet>
  >,
  TError = HTTPValidationError
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAvatarSessionApiV1AvatarsLivekitSessionsSessionIdGetQueryOptions(
      sessionId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
